import {
  propertyCostsSchema,
  propertySchema,
  type Property,
  type PropertyCosts,
  type PropertyCostsInput,
  type PropertyInput,
  type PropertyUpdate,
} from '@app/shared';
import { z } from 'zod';
import { apiFetch, ApiRequestError } from '@/lib/api';

export function fetchProperties(includeArchived = false): Promise<Property[]> {
  return apiFetch(`/api/properties?includeArchived=${includeArchived}`, { schema: z.array(propertySchema) });
}

export function fetchProperty(id: number): Promise<Property> {
  return apiFetch(`/api/properties/${id}`, { schema: propertySchema });
}

export function createProperty(input: PropertyInput): Promise<Property> {
  return apiFetch('/api/properties', { method: 'POST', body: input, schema: propertySchema });
}

export function updateProperty(id: number, input: PropertyUpdate): Promise<Property> {
  return apiFetch(`/api/properties/${id}`, { method: 'PATCH', body: input, schema: propertySchema });
}

export function archiveProperty(id: number, archived: boolean): Promise<Property> {
  return updateProperty(id, { archived });
}

/** `null` : aucun coût d'acquisition saisi pour ce bien (pas encore d'erreur, un état normal). */
export function fetchPropertyCosts(id: number): Promise<PropertyCosts | null> {
  return apiFetch(`/api/properties/${id}/costs`, { schema: propertyCostsSchema }).catch((error: unknown) => {
    if (error instanceof ApiRequestError && error.code === 'costs_not_set') return null;
    throw error;
  });
}

export function savePropertyCosts(id: number, input: PropertyCostsInput): Promise<PropertyCosts> {
  return apiFetch(`/api/properties/${id}/costs`, { method: 'PUT', body: input, schema: propertyCostsSchema });
}
